import Newsletter from '../views/newsletters/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const NewsletterCreate = () => import('../views/newsletters/Create.vue');
const NewsletterEdit = () => import('../views/newsletters/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/newsletters',
		name: 'newsletters',
		component: Newsletter,
		beforeEnter: auth,
	},
	{
		path: '/newsletters/new',
		name: 'newsletter-new',
		component: NewsletterCreate,
		beforeEnter: auth,
	},
	// :id e' l'_id dell'iscritto (24 caratteri esadecimali): "new" non puo' mai finire qui
	{
		path: '/newsletters/:id([0-9a-fA-F]{24})',
		name: 'newsletter-edit',
		component: NewsletterEdit,
		beforeEnter: auth,
	},
];
